/**
 * Config file with some variables.
 * @devEnvironments
 */
let backendEnv = 'http://localhost:8000';

// production values
const REACT_APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;

if (REACT_APP_ENVIRONMENT === 'cloud-production') {
  backendEnv = 'https://d27nsfqs2eq1zz.cloudfront.net';
} else if (REACT_APP_ENVIRONMENT === 'cloud-staging2') {
  backendEnv = 'http://hai-backend-staging-2.salvus.me';
} else if (REACT_APP_ENVIRONMENT === 'cloud-staging1') {
  backendEnv = 'http://hai-backend-staging-1.salvus.me';
} else if (REACT_APP_ENVIRONMENT === 'cloud-gcene-homologation') {
  backendEnv = 'http://gcene-homologation-backend.salvus.me';
} else if (REACT_APP_ENVIRONMENT === 'gcene') {
  backendEnv = 'https://d2totq4g0ekv4v.cloudfront.net';
} else if (REACT_APP_ENVIRONMENT === 'develop') {
  backendEnv = 'http://hai-backend-develop.salvus.me';
} else if (REACT_APP_ENVIRONMENT === 'vidaemcasa') {
  backendEnv = 'https://dje9uksv4mqhn.cloudfront.net';
} else if (REACT_APP_ENVIRONMENT === 'medsenior') {
  backendEnv = 'https://d2ecgnmsktvkjv.cloudfront.net';
} else if (REACT_APP_ENVIRONMENT === 'shared-env') {
  backendEnv = 'https://dh05ysz92g0sw.cloudfront.net';
} else if (REACT_APP_ENVIRONMENT === 'eav') {
  backendEnv = 'https://d2xkzfhe95qi84.cloudfront.net';
} else if (REACT_APP_ENVIRONMENT === 'sulcapixaba') {
  backendEnv = 'https://d3htzkgdkrgdci.cloudfront.net';
} else if (REACT_APP_ENVIRONMENT === 'special') {
  backendEnv = 'https://d2bi8pazkbbq0e.cloudfront.net';
} else if (REACT_APP_ENVIRONMENT === 'gcene-sap') {
  backendEnv = 'https://dny8nf6k199te.cloudfront.net';
} else if (REACT_APP_ENVIRONMENT === 'exc') {
  backendEnv = 'https://d2bi8pazkbbq0e.cloudfront.net';
}

export default backendEnv;
